module.exports = __webpack_public_path__ + "static/media/CF.b6bda036.svg";